<template>
    <div>
      <v-card-text>
        <v-autocomplete
            v-model="local_case.case_type.id"
            :items="casetypeResults"
            :search-input.sync="casetypeSearch"
            :disabled="loading || isShown"
            label="Case Type"
            item-text="name"
            item-value="id"
            persistent-hint
            hint="Only administrators can change the Case Type after a Case is created"
            outline
            :return-object="false"
            @input="casetypeSearch = ''"
        >
            <template slot="no-data">
                <div
                  class="autocomplete-no-data"
                >
                  <div
                    v-if="casetypeSearch"
                  >
                    <div
                      v-if="loading"
                    >
                      Searching for '{{ casetypeSearch }}'...
                    </div>
                    <div
                      v-else
                    >
                      <i>No results for '{{ casetypeSearch }}'</i>
                    </div>
                  </div>
                  <div
                    v-else
                  >
                    Start typing to search
                  </div>
                </div>
            </template>
        </v-autocomplete>     
        <br />
        <v-expand-transition>
            <div>
                <v-text-field
                    v-model="local_case.case_number"
                    persistent-hint
                    :disabled="loading"
                    outline
                    label="Case Number"
                    hint="Must be unique within your organization if set"
                    :error-messages="validationError && validationError.hasOwnProperty('case_number') ? validationError['case_number'] : []"
                />
                <v-text-field
                    v-model="local_case.case_title"
                    persistent-hint
                    :disabled="loading"
                    outline
                    label="Case Title"
                    hint="A free-text title for the Case"
                />
                <v-switch
                    v-model="local_case.active"
                    persistent-hint
                    solo
                    :disabled="loading"
                    :label="local_case.active ? 'Open' : 'Closed'"
                    hint="Toggle the active state to hide the case and its forms from the Contact and search results"
                />
            </div>
        </v-expand-transition>
      </v-card-text>
      <v-card-actions>
          <v-spacer />
          <v-btn
              flat
              :disabled="loading"
              @click="$emit('cancel')"
          >
              Cancel
          </v-btn>
          <v-btn
              color="primary"
              :disabled="loading"
              @click="changingCasetype ? saveCasetype() : save()"
          >
              Save
          </v-btn>
      </v-card-actions>
    </div>
  </template>
  
  <script>
  import api from '@/api'
  import { mapGetters } from 'vuex'
  
  export default {
      name: 'CaseSettings',
      props: ['xcase', 'id'],
      data () {
          return {
              loading: false,
              local_case: null,
              validationError: null,
              casetypeResults: [],
              casetypeSearch: null
          }
      },
      created () {
          if (this.xcase) {
            this.local_case = JSON.parse(JSON.stringify(this.xcase))
            this.casetypeResults = [
                this.local_case.case_type
            ]
          } else {
              if (this.id)
                  this.fetch()
          }
      },
      computed: {
        ...mapGetters('auth', [
            'userInfo'
        ]),
        isShown(){
            return !this.userInfo.admin
        },
        changingCasetype(){
            return this.local_case.case_type.id != this.xcase.case_type.id
        }
      },
      watch: {
        casetypeSearch () {
            if(this.casetypeSearch){
                this.fetchCaseTypes()
            }
        }
      },
      methods: {
          fetch () {
              this.loading = true
              api.cases.cases.get(this.id)
              .then((data) => {
                  this.local_case = data
                  this.casetypeResults = [
                    this.local_case.case_type
                  ]
              })
              .finally(() => {
                  this.loading = false
              })
  
          },
          saveCasetype () {
            api.cases.cases.changeCasetype(this.local_case)
                .then(() => {
                    this.save()
                })
          },
          save () {
            this.loading = true
            api.cases.cases.save({
                id: this.local_case.id,
                case_number: this.local_case.case_number,
                case_title: this.local_case.case_title,
                active: this.local_case.active
            }, true)
                .then(() => {
                    this.$emit('save')
                })
                .catch((data) => {
                    this.validationError = data.response.data
                })
                .finally(() => {
                    this.loading = false
                })
          },
          fetchCaseTypes() {
            api.cases.casetype.list({
                search: this.casetypeSearch
            }) .then(data => {
                this.casetypeResults = data.results
            })
          }
      }
  }
  </script>
  
  <style>
  
  </style>